import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { share, switchMap, takeUntil } from 'rxjs/operators';
import { Notification } from 'src/app/shared/models/notification';
import { ConstantsService } from '../../constant/constants.service';
import { environment } from 'src/environments/environment';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { FacadeService } from '../../facade.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class NotificationService implements OnDestroy {
	private stopReloding = new Subject<void>();
	environment = environment;
	constructor(
		private appConstants: ConstantsService,
		private facade: FacadeService,
		private genericCrudService: GenericCrudService
	) {}

	getNotifications(idSender: number): Observable<any> {
		return timer(
			1,
			this.facade.dataStorageService.getRefreshNotificationRateInSeconds() *
				1000
		).pipe(
			switchMap(() => {
				return this.genericCrudService.genericGetAPIData(
					`${this.appConstants.notificationsUrl}/${idSender}`
				);
			}),
			share(),
			takeUntil(this.stopReloding)
		);
	}

	getNotificationsOnlyOnce(idSender: number): Observable<Notification> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.notificationsUrl}/${idSender}`,
			'getNotificationsOnlyOnce'
		);
	}

	getMessageNotifications(idSender: number): Observable<MessageNotification[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.messageNotificationUrl}/${idSender}`,
			'getMessageNotifications'
		);
	}

	clearMessageNotification(idSender: number, idReceiver: number) {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.notificationsUrl}/reset/${idSender}/${idReceiver}`,
			`clearMessageNotification`,
			''
		);
	}

	ngOnDestroy() {
		this.stopReloding.next();
	}
}
